<app-clock />
<a class="button" [href]="diaryUrl" target="_blank">{{ 'navigation.diary' | translate }}</a>
<app-user-menu />
